export default {
  title: {
    en: 'Who is this gift for?',
  },
  maleButtonTitle: {
    en: 'Buy the gift for him',
  },
  femaleButtonTitle: {
    en: ' Buy the gift for her',
  },
}
